import {createClient} from '@sanity/client'

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID
const dataset = process.env.REACT_APP_SANITY_DATASET || 'production'

export function isSanityConfigured() {
  return Boolean(projectId && String(projectId).trim().length > 0)
}

let client

export function getSanityClient() {
  if (!isSanityConfigured()) return null
  if (!client) {
    client = createClient({
      projectId,
      dataset,
      apiVersion: '2024-01-01',
      useCdn: true,
      token: process.env.REACT_APP_SANITY_READ_TOKEN || undefined,
    })
  }
  return client
}
